module.exports = __webpack_public_path__ + "img/icon-password.b19bb749.svg";